<!--
 * @Description:客户详情底部按钮
 * @Author: cxh
 * @Date: 2022-09-20 15:19:34
 * @LastEditTime: 2023-03-06 20:18:03
 * @LastEditors: cxh
-->
<template>
  <cos-footer-button :loading="loading" hideOk>
    <a-button @click="handleTransfer" v-permission="permissionPage?.transfer">{{ $t('btn.transferCustomer') }}</a-button>
    <a-button @click="handleAddConcat" v-permission="permissionPage?.concat_add">{{ $t('btn.addContact') }}</a-button>
    <a-button @click="handleAddFollow" v-permission="permissionPage?.follow_add">{{ $t('btn.writeFollow') }}</a-button>
    <a-button @click="hanleVisitor" v-permission="permissionPage?.visitor_add">{{ $t('btn.addVisitor') }}</a-button>
    <SellerButton controlType="none" :workCode="workCode" @click="handleAddBuss" v-permission="permissionPage?.buss_add"
      >{{ $t('btn.addBussiess') }}</SellerButton
    >
    <a-button type="primary" @click="handleEdit" v-permission="permissionPage?.edit">{{ $t('btn.edit') }}</a-button>
  </cos-footer-button>
  <!--转移客户--->
  <TransferModel ref="transferModelRef" @success="successPage('base')" />
  <!--新增联系人--->
  <ConcatModal ref="concatModalRef"  @success="successPage('contact')" :contactRefId="route.query.cosId" />
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import TransferModel from './transferModel.vue'
import ConcatModal from '@/components/TabsContacts/ofbu/editModal.vue'
const transferModelRef = ref()
const concatModalRef = ref()
const router = useRouter()
const route = useRoute()
const emit = defineEmits(['success'])
const props = defineProps({
  workCode: {
    type: String
  },
  type: {
    type: String
  },
  loading: {
    type: Boolean
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  }
})
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle([{ cosId: route.query.cosId }])
}
// 新增联系人
const handleAddConcat = () => {
  concatModalRef.value.toggle()
}
// 新增访客计划
const hanleVisitor = () => {
  router.push({
    path: '/ofbu/visitorProgram/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}
// 转移客户和新增联系人成功回调
const successPage = (tag: any) => {
  emit('success', tag)
}
// 新增跟进记录
const handleAddFollow = () => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: {
      followRefId: route.query.cosId
    }
  })
}
// 新增商机
const handleAddBuss = () => {
  router.push({
    path: '/ofbu/business/add',
    query: {
      saleChanceRefId: route.query.cosId
    }
  })
}
//  编辑
const handleEdit = () => {
  let path = ''
  if (props.type === 'clients') {
    path = '/ofbu/clients/edit'
  } else if (props.type === 'potential') {
    path = '/ofbu/potential/edit'
  } else if (props.type === 'contract') {
    path = '/ofbu/contract/edit'
  }
  if (path) {
    router.push({
      path,
      query: {
        cosId: route.query.cosId
      }
    })
  }
}
</script>
<script lang="ts">
export default { name: 'viewFooterBtn' }
</script>
